import { provideEffects } from '@ngrx/effects';
import {
  AliasesEffect,
  AddDomainDialogEffect,
  DeleteDomainDialogEffect,
  DomainExistenceCheckDialogEffect,
  EditDomainDialogEffect,
  PurgeCacheDialogEffect,
  WarmCacheDialogEffect,
  WarmLogDialogEffect,
  AccessLogDialogEffect
} from '@vshosting/cdn/features';

export const FEATURES_EFFECTS = [
  provideEffects(AliasesEffect),
  provideEffects(AddDomainDialogEffect),
  provideEffects(DeleteDomainDialogEffect),
  provideEffects(DomainExistenceCheckDialogEffect),
  provideEffects(EditDomainDialogEffect),
  provideEffects(PurgeCacheDialogEffect),
  provideEffects(AccessLogDialogEffect),
  provideEffects(WarmCacheDialogEffect),
  provideEffects(WarmLogDialogEffect)
] as const;
